import { CSSProperties, useRef, useState, useContext, useEffect } from "react";
import { hasAllAuthorizationsOptions, insurancePoliciesOptions, projectActivitiesOptions, projectSpaceOptions, reportingOrCertificationOptions, requiresLicensingOptions } from "../../../Utils/PleaSocioEnvironmentalTabOptions";
import { GetPleaSocioEnvironmentalbyPleaId, PleaSocioEnvironmentalPost } from "../../../API/PleaSocioEnvironmentalAPI";
import { AuthContext } from "../../../Contexts/AuthContext";
import { useToast } from '../../../antd/hooks/toast';
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import useLoading from "../../../Hooks/useLoading";
import { Checkbox, Radio, Select, Typography } from "antd";

const { Option } = Select;

interface SocioEnvironmentalTab {
    pleaId: string;
    companyId: string;
}
type FormStateKeys =
    'reportingOrCertification' |
    'insurancePolicies' |
    'projectSpace' |
    'projectActivities' |
    'requiresLicensing' |
    'hasAllAuthorizations';

interface FormState {
    reportingOrCertification: string[];
    insurancePolicies: string[];
    projectSpace: string[];
    projectActivities: string[];
    requiresLicensing: string[];
    hasAllAuthorizations: string[];
}

const titleSize = '18px'
const textSize = '16px'

export const SocioEnvironmentalTab = ({ pleaId, companyId }: SocioEnvironmentalTab) => {

    const { userEmail } = useContext(AuthContext);
    const toast = useToast();
    const { loading, toggleLoading } = useLoading();
    const [clicked, setClicked] = useState(false);
    const [contaminatedOrDegradedArea, setContaminedOrDegradedArea] = useState<string>('');
    const [formState, setFormState] = useState<FormState>({
        reportingOrCertification: [],
        insurancePolicies: [],
        projectSpace: [],
        projectActivities: [],
        requiresLicensing: [],
        hasAllAuthorizations: []
    });

    const handleChecked = (checkedValue: any, type: FormStateKeys) => {
        setClicked(true);
        setFormState((prev) => ({
            ...prev,
            [type]: checkedValue
        }));
    };

    const GetPleaSocioEnvironmental = async () => {
        try {
            toggleLoading(true);
            if (pleaId) {
                await GetPleaSocioEnvironmentalbyPleaId(pleaId).then((resp: IResponseProps) => {
                    if (resp.statusCode == 200) {
                        setContaminedOrDegradedArea(resp.data.contaminatedOrDegradedArea);
                        setFormState({
                            reportingOrCertification: resp.data.reportingOrCertification.split(',') || null,
                            insurancePolicies: resp.data.insurancePolicies.split(',') || null,
                            projectSpace: resp.data.projectSpace.split(',') || null,
                            projectActivities: resp.data.projectActivities.split(',') || null,
                            requiresLicensing: resp.data.requiresLicensing.split(',') || null,
                            hasAllAuthorizations: resp.data.hasAllAuthorizations.split(',') || null
                        });
                    }
                }).finally(() => {
                    toggleLoading(false);
                });
            }
        } catch (error: any) {
            toast.error({ message: 'Erro ao consultar dados!' });
            toggleLoading(false);
        }
    };

    const handleSubmit = async () => {

        try {
            toggleLoading(true);
            const response = await PleaSocioEnvironmentalPost(
                contaminatedOrDegradedArea,
                formState.reportingOrCertification.toString(),
                formState.insurancePolicies.toString(),
                formState.projectSpace.toString(),
                formState.projectActivities.toString(),
                formState.requiresLicensing.toString(),
                formState.hasAllAuthorizations.toString(),
                userEmail,
                pleaId
            ).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    toast.success({ message: `Dados atualizados com sucesso!` });
                }
            })
                .finally(() => {
                    toggleLoading(false);
                });
        } catch (error: any) {
            toast.error({ message: 'Erro ao inserir dados!' });
        }
    };

    const onChanged = (value: string) => {
        setContaminedOrDegradedArea(value);
        setClicked(true);
    }

    useEffect(() => {
        if (clicked) {
            handleSubmit();
        }
    }, [formState, contaminatedOrDegradedArea]);

    useEffect(() => {
        GetPleaSocioEnvironmental();
    }, []);

    return (
        <div>
            <div style={{ margin: '20px 0px' }}>
                <Typography style={{ width: '100%', fontSize: textSize }}>A executora do projeto possui área contaminada e/ou degradada?</Typography>
                <Radio.Group
                    value={contaminatedOrDegradedArea}
                    onChange={(e) => onChanged(e.target.value)}
                    style={{ display: 'flex', flexDirection: 'row', marginTop: '16px', gap: '32px'}}>
                        <Radio  value={'Sim'}>Sim</Radio>
                        <Radio  value={'Não'}>Não</Radio>
                    </Radio.Group>
            </div>

            <div style={{ display: 'flex', margin: '0px 30px 0px 0px', flexDirection: 'column' }}>

                <Typography style={{ fontSize: titleSize, color: 'var(--color-blue)', margin: '0px 0px 8px 0px' }}>Quadro Socioambiental da Executora</Typography>
                <Typography style={{ fontSize: textSize, color: 'var(--color-black)', margin: '0px 0px 15px 0px' }}>Assinale qual(is) instrumento(s) de gestão sustentável, reporte socioambiental ou certificação social em âmbito nacional ou internacional a executora do projeto adota.</Typography>

                <Checkbox.Group
                    value={formState.reportingOrCertification}
                    onChange={(checkedValue) => handleChecked(checkedValue, 'reportingOrCertification')}
                    style={{ width: '100%', marginBottom: 15 }}>
                        <div style={{ display: 'flex', width: '100%', marginBottom: 8 }}>
                            <div style={{width: '10%'}}>
                                <Checkbox value="Não se aplica" style={{flex: 1}}>Não se aplica</Checkbox>
                            </div>
                            <div style={{width: '90%'}}>
                                <Checkbox value="ISO 14001" style={{flex : 1}}>ISO 14001</Checkbox>
                            </div>
                        </div>
                        <div style={{ display: 'flex', width: '100%', marginBottom: 8 }}>
                            <div style={{width: '10%'}}>
                                <Checkbox value="OHSAS 18000">OHSAS 18000</Checkbox>
                            </div>
                            <div style={{width: '90%'}}>
                                <Checkbox value="Indicadores Ethos">Indicadores Ethos</Checkbox>
                            </div>
                        </div>
                        <div style={{ display: 'flex', width: '100%', marginBottom: 8 }}>
                            <div style={{width: '10%'}}>
                                <Checkbox value="ISE - Bovespa">ISE - Bovespa</Checkbox>
                            </div>
                            <div style={{width: '90%'}}>
                                <Checkbox value="Relatório no formato Global Reporting Initiative">
                                    Relatório no formato Global Reporting Initiative
                                </Checkbox>
                            </div>
                        </div>
                        <div style={{ display: 'flex', width: '100%', gap: 80, marginBottom: 8 }}>
                            <Checkbox value="Outros">Outros</Checkbox>
                        </div>
                </Checkbox.Group>

                <Typography style={{ fontSize: textSize, color: 'var(--color-black)', margin: '15px 0px 15px 0px' }}>
                     As apólices de seguro válidas e vigentes na executora do projeto cobrem a responsabilização por eventuais impactos socioambientais cometidos?
                </Typography>
                <Checkbox.Group
                    value={formState.insurancePolicies}
                    onChange={(checkedValue) => handleChecked(checkedValue, 'insurancePolicies')}                        
                    style={{ display: 'flex' ,width: '100%',marginBottom: 15 }}>

                    {insurancePoliciesOptions.map((option) => (
                        <Checkbox value={option} key={option} style={{ width: '100%', marginBottom: 8 }}>
                            {option}
                        </Checkbox>
                    ))}
                </Checkbox.Group>

                <Typography style={{ fontSize: titleSize, color: 'var(--color-blue)', margin: '15px 0px 15px 0px' }}>
                    Quadro Socioambiental do Projeto
                </Typography>
                <Typography style={{ fontSize: textSize, color: 'var(--color-black)', margin: '0px 0px 15px 0px' }}>
                    O projeto será executado em quais espaços?
                </Typography>
                <Checkbox.Group
                    value={formState.projectSpace}
                    onChange={(checkedValue) => handleChecked(checkedValue, 'projectSpace')}
                    style={{ display: 'flex' ,width: '100%', marginBottom: 15 }}>
                        <div style={{ display: 'flex', width: '100%', marginBottom: 8 }}>
                            <div style={{width: '30%'}}>
                                <Checkbox value="Zona Urbana" style={{flex: 1}}>Zona Urbana</Checkbox>
                            </div>
                            <div style={{width: '70%'}}>
                                <Checkbox value="Zona Rural" style={{flex : 1}}>Zona Rural</Checkbox>
                            </div>
                        </div>
                        <div style={{ display: 'flex', width: '100%', marginBottom: 8 }}>
                            <div style={{width: '30%'}}>
                                <Checkbox value="Distrito Industrial">Distrito Industrial</Checkbox>
                            </div>
                            <div style={{width: '70%'}}>
                                <Checkbox value="Interior ou entorno de Unidade de Proteção Integral">Interior ou entorno de Unidade de Proteção Integral</Checkbox>
                            </div>
                        </div>
                        <div style={{ display: 'flex', width: '100%', marginBottom: 8 }}>
                            <div style={{width: '30%'}}>
                                <Checkbox value="Interior de Unidade de Uso Sustentavel">Interior de Unidade de Uso Sustentavel</Checkbox>
                            </div>
                            <div style={{width: '70%'}}>
                                <Checkbox value="Área reconhecida como Patrimônio Histórico ou Cultural, Sitio Arqueológico ou Espeleológico">Área reconhecida como Patrimônio Histórico ou Cultural, Sitio Arqueológico ou Espeleológico</Checkbox>
                            </div>
                        </div>
                        <div style={{ display: 'flex', width: '100%', marginBottom: 8 }}>
                            <Checkbox value="Interior de Áreas de Preservação Permanente">Interior de Áreas de Preservação Permanente</Checkbox>
                        </div>
                </Checkbox.Group>
                    

                <Typography style={{ fontSize: textSize, color: 'var(--color-black)', margin: '15px 0px 15px 0px' }}>
                    Caso o projeto se enquadre nas atividades listadas abaixo, favor selecionar:
                </Typography>
                <Checkbox.Group
                    value={formState.projectActivities}
                    onChange={(checkedValue) => handleChecked(checkedValue, 'projectActivities')}
                    style={{ width: '100%' ,marginBottom: 15 }}>

                    {projectActivitiesOptions.map((option) => (
                        <Checkbox value={option} key={option} style={{ width: '100%', marginBottom: 8 }}>
                            {option}
                        </Checkbox>
                    ))}
                </Checkbox.Group>

                <Typography style={{ fontSize: textSize, color: 'var(--color-black)', margin: '15px 0px 15px 0px' }}>
                    As atividades desempenhadas no projeto necessitarão de licenciamento, estudos ou relatórios ambientais específicos?
                </Typography>
                <Checkbox.Group
                    value={formState.requiresLicensing}
                    onChange={(checkedValue) => handleChecked(checkedValue, 'requiresLicensing')}
                    style={{ display: 'flex' ,width: '100%', marginBottom: 15 }}>
                        <div style={{ display: 'flex', width: '100%', marginBottom: 8 }}>
                            <div style={{width: '50%'}}>
                                <Checkbox value="Não" style={{flex: 1}}>Não</Checkbox>
                            </div>
                            <div style={{width: '50%'}}>
                                <Checkbox value="Não e a executora possui declaração de desnecessidade emitida pelo órgão ambiental" style={{flex : 1}}>Não e a executora possui declaração de desnecessidade emitida pelo órgão ambiental</Checkbox>
                            </div>
                        </div>
                        <div style={{ display: 'flex', width: '100%', marginBottom: 8 }}>
                            <div style={{width: '50%'}}>
                                <Checkbox value="Não, sendo aplicável(is) a(s) licença(s) já existente(s) para as atividades rotineiramente desenvolvidas pela executora">Não, sendo aplicável(is) a(s) licença(s) já existente(s) para as atividades rotineiramente desenvolvidas pela executora</Checkbox>
                            </div>
                            <div style={{width: '50%'}}>
                                <Checkbox value="Sim">Sim</Checkbox>
                            </div>
                        </div>
                </Checkbox.Group>

                <Typography style={{ fontSize: textSize, color: 'var(--color-black)', margin: '15px 0px 15px 0px' }}>
                    O projeto já possui todas as autorizações, estudos e licenças ambientais exigidas pela legislação para a sua execução integral?
                </Typography>
                <Checkbox.Group
                    value={formState.hasAllAuthorizations}
                    onChange={(checkedValue) => handleChecked(checkedValue, 'hasAllAuthorizations')}
                    style={{ display: 'flex' ,width: '100%', marginBottom: 15 }}>
                        <div style={{ display: 'flex', width: '100%', marginBottom: 8 }}>
                            <div style={{width: '50%'}}>
                                <Checkbox value="Não há exigência de autorizações, estudos e licenças ambientais para a execução do projeto">Não há exigência de autorizações, estudos e licenças ambientais para a execução do projeto</Checkbox>
                            </div>
                            <div style={{width: '50%'}}>
                                <Checkbox value="Possui as autorizações, estudos e licenças ambientais para pelo menos as etapas iniciais do projeto">Possui as autorizações, estudos e licenças ambientais para pelo menos as etapas iniciais do projeto</Checkbox>
                            </div>
                        </div>
                        <div style={{ display: 'flex', width: '100%', marginBottom: 8 }}>
                            <div style={{width: '50%'}}>
                                <Checkbox value="Não possui as autorizações, estudos e licenças ambientais necessárias para a execução do projeto">Não possui as autorizações, estudos e licenças ambientais necessárias para a execução do projeto</Checkbox>
                            </div>
                        </div>
                </Checkbox.Group>

            </div>
        </div>
    )
}